export const getInitialState = () => ({
    code: undefined,
    hadPassengerNameError: undefined
});
